import Enum from '@/modules/core/app/helpers/Enum';
import { EstateTaxFormTypeKey } from '@/modules/estatetaxform/enums/EstateTaxFormTypeKey';

export class EstateTaxFormType extends Enum {
  key!: EstateTaxFormTypeKey;
  value!: string;

  static AUTH_REP_FORM: EstateTaxFormType = {
    key: EstateTaxFormTypeKey.AUTH_REP_FORM,
    get value(): string {
      return 'Authorize Representative Form';
    }
  };

  static T1: EstateTaxFormType = {
    key: EstateTaxFormTypeKey.T1,
    get value(): string {
      return 'T1 - Income Tax Return';
    }
  };

  static T3: EstateTaxFormType = {
    key: EstateTaxFormTypeKey.T3,
    get value(): string {
      return 'T3 - Trust Income Tax Return';
    }
  };

  static T1_ADJUSTMENT: EstateTaxFormType = {
    key: EstateTaxFormTypeKey.T1_ADJUSTMENT,
    get value(): string {
      return 'T1 Adjustment';
    }
  };

  static T3_ADJUSTMENT: EstateTaxFormType = {
    key: EstateTaxFormTypeKey.T3_ADJUSTMENT,
    get value(): string {
      return 'T3 Adjustment';
    }
  };

  static CLEARANCE_CERTIFICATE: EstateTaxFormType = {
    key: EstateTaxFormTypeKey.CLEARANCE_CERTIFICATE,
    get value(): string {
      return 'Clearance certificate';
    }
  };

  static RC4288: EstateTaxFormType = {
    key: EstateTaxFormTypeKey.RC4288,
    get value(): string {
      return 'RC4288';
    }
  };

  static FORM_56: EstateTaxFormType = {
    key: EstateTaxFormTypeKey.FORM_56,
    get value(): string {
      return 'Form 56';
    }
  };

  static TEN_FORTY: EstateTaxFormType = {
    key: EstateTaxFormTypeKey.TEN_FORTY,
    get value(): string {
      return '1040';
    }
  };

  static TEN_FORTY_ADJUSTMENT: EstateTaxFormType = {
    key: EstateTaxFormTypeKey.TEN_FORTY_ADJUSTMENT,
    get value(): string {
      return '1040 Adjustment';
    }
  };

  static TEN_FORTY_ONE: EstateTaxFormType = {
    key: EstateTaxFormTypeKey.TEN_FORTY_ONE,
    get value(): string {
      return '1041';
    }
  };

  static TEN_FORTY_ONE_ADJUSTMENT: EstateTaxFormType = {
    key: EstateTaxFormTypeKey.TEN_FORTY_ONE_ADJUSTMENT,
    get value(): string {
      return '1041 Adjustment';
    }
  };

  static IRS_TERMINATION: EstateTaxFormType = {
    key: EstateTaxFormTypeKey.IRS_TERMINATION,
    get value(): string {
      return 'IRS Termination';
    }
  };

  static getAllCanadianFormTypes(): EstateTaxFormType[] {
    return [
      EstateTaxFormType.AUTH_REP_FORM,
      EstateTaxFormType.T1,
      EstateTaxFormType.T3,
      EstateTaxFormType.T1_ADJUSTMENT,
      EstateTaxFormType.T3_ADJUSTMENT,
      EstateTaxFormType.CLEARANCE_CERTIFICATE,
      EstateTaxFormType.RC4288
    ];
  }

  static getAllUSFormTypes(): EstateTaxFormType[] {
    return [
      EstateTaxFormType.FORM_56,
      EstateTaxFormType.TEN_FORTY,
      EstateTaxFormType.TEN_FORTY_ADJUSTMENT,
      EstateTaxFormType.TEN_FORTY_ONE,
      EstateTaxFormType.TEN_FORTY_ONE_ADJUSTMENT,
      EstateTaxFormType.IRS_TERMINATION
    ];
  }

  static hasYearField(key: EstateTaxFormTypeKey): boolean {
    return [
      EstateTaxFormType.T1.key,
      EstateTaxFormType.T3.key,
      EstateTaxFormType.T1_ADJUSTMENT.key,
      EstateTaxFormType.T3_ADJUSTMENT.key,
      EstateTaxFormType.TEN_FORTY.key,
      EstateTaxFormType.TEN_FORTY_ONE.key,
      EstateTaxFormType.TEN_FORTY_ADJUSTMENT.key,
      EstateTaxFormType.TEN_FORTY_ONE_ADJUSTMENT.key
    ].includes(key);
  }
}
